import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from "../Components/Home/Home";
import Login from "../Components/Login/Login";
import Dashboard from "../Components/Dashboard/Dashboard";
import RegisterShop from "../Components/RegisterShop/RegisterShop";
import NotFound from "../Components/404/NotFound";
import RegisterOptions from "../Components/RegisterOptions/RegisterOptions";
import Demo from "../Components/Demo/Demo";

function Routing() {
  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/signin" component={Login} />
      <Route exact path="/dashboard" component={Dashboard} />
      <Route exact path="/register" component={RegisterShop} />
      <Route exact path="/registerOptions" component={RegisterOptions} />
      <Route exact path="/demo" component={Demo} />
      <Route component={NotFound} />
    </Switch>
  );
}

export default Routing;
